import { PlayerInfo } from '@players/components/player-info/player-info';
import styles from './info-and-socials-section.module.scss';
import { useAppTranslation } from 'hooks/use-translates';

export type PlayerSocial = {
    type: 'Twitter/X' | 'Instagram' | 'Twitch' | 'TikTok';
    hide?: boolean;
    username?: string;
};

type PlayerInfoProps = {
    dateOfBirth?: string;
    birthCity?: string;
    birthCountry?: string;
    dateJoined?: string;
    socials?: PlayerSocial[];
};

export const InfoAndSocialsSection = ({
    dateOfBirth,
    birthCity,
    birthCountry,
    dateJoined,
    socials = [],
}: PlayerInfoProps) => {
    const { t } = useAppTranslation();
    let birthValue = '';
    if (birthCity && birthCountry) {
        birthValue = `${birthCity}, ${birthCountry}`;
    } else if (birthCity) {
        birthValue = birthCity;
    } else if (birthCountry) {
        birthValue = birthCountry;
    }
    return (
        <div className={styles['player-info-socials']}>
            {dateOfBirth && <PlayerInfo label={t('players_profile.info_date', undefined, 'Date of birth')} value={dateOfBirth} />}
            {birthValue && <PlayerInfo label={t('players_profile.info_birth_city', undefined, 'Birth city')} value={birthValue} />}
            {dateJoined && <PlayerInfo label={t('players_profile.info_joined_city', undefined, 'Joined City')} value={dateJoined} />}
            {socials.length > 0 && (
                <PlayerInfo type="socials" label={t('players_profile.social_section_title', undefined, 'Follow on')} value={socials} />
            )}
        </div>
    );
};

export default InfoAndSocialsSection;
